import React from 'react';
import PropTypes from 'prop-types';
import Popup from 'reactjs-popup';

// `V3MobileActionSheet` intentionally does NOT use this wrapper — it is a
// transient menu without a drag handle, and it uses a slightly different
// content style (no `#fff` background).

const BASE_CONTENT_STYLE = {
  border: 'none',
  borderRadius: '16px 16px 0 0',
  boxShadow: '0 -4px 12px rgba(0,0,0,0.1)',
  width: '100vw',
  maxWidth: '100vw',
  margin: 0,
  padding: 0,
  position: 'fixed',
  bottom: 0,
  left: 0,
  right: 0,
  background: 'var(--od-c-ffffff, #fff)',
};

const BASE_OVERLAY_STYLE = {
  background: 'rgba(0,0,0,0.4)',
  display: 'flex',
  alignItems: 'flex-end',
  justifyContent: 'center',
};

const V3MobileBottomSheet = ({
  open,
  onClose,
  showDragHandle,
  contentStyle,
  overlayStyle,
  closeOnDocumentClick,
  modal,
  children,
  ...popupProps
}) => (
  <Popup
    open={open}
    onClose={onClose}
    modal={modal}
    closeOnDocumentClick={closeOnDocumentClick}
    contentStyle={{ ...BASE_CONTENT_STYLE, ...(contentStyle || {}) }}
    overlayStyle={{ ...BASE_OVERLAY_STYLE, ...(overlayStyle || {}) }}
    {...popupProps}
  >
    {showDragHandle && <div className="add-artist-modal__handle" aria-hidden="true" />}
    {children}
  </Popup>
);

V3MobileBottomSheet.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  showDragHandle: PropTypes.bool,
  contentStyle: PropTypes.object,
  overlayStyle: PropTypes.object,
  closeOnDocumentClick: PropTypes.bool,
  modal: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

V3MobileBottomSheet.defaultProps = {
  showDragHandle: true,
  contentStyle: null,
  overlayStyle: null,
  closeOnDocumentClick: true,
  modal: true,
};

export default V3MobileBottomSheet;
